// Copy for features an account's plan doesn't include. Plans and add-ons are
// sold by ScopeStack staff, so the only call to action is emailing support.
// Keep in sync with app/helpers/plan_features_helper.rb (a test checks).
export const SUPPORT_EMAIL = "support@scopestack.io";

export const FEATURE_NAMES: Readonly<Record<string, string>> = Object.freeze({
  "autotask-integration": "CRM and PSA Integration",
  "managed-services-scoping": "Managed Services",
  "product-quoting": "Product Quoting",
  "3rd-party-scoping": "Scoping Third-Party services",
  "scopestack-connect": "Scoping ScopeStack connect Partner services",
  "rate-table-management": "Multiple Rate Tables",
  "multi-currency": "Multiple Currencies",
  "advanced-pricing": "Advanced Pricing and Payment Credits",
  "workflow-approval": "Project Approval workflow",
  "recommendation-engine": "Surveys and the Recommendation Engine",
});

export const notInPlanMessage = (entitlement: string): string => {
  const feature = Object.prototype.hasOwnProperty.call(
    FEATURE_NAMES,
    entitlement
  )
    ? FEATURE_NAMES[entitlement]
    : "This feature";
  return `${feature} isn't included in your plan. Email ${SUPPORT_EMAIL} to add it.`;
};
